var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableSimpleBlock',{attrs:{"title":"Incidencias según tipología","items":_vm.issueReasonReportData,"fields":_vm.fields,"isLoading":_vm.isIssueReasonReportLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }